import { Component, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { GtmService } from '@common/services/gtm.service';
import { RobotsService } from '@common/services/robots.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly gtmService = inject(GtmService);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly robots = inject(RobotsService);

  constructor() {
    this.gtmService.init();

    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe(() => {
      let route = this.activatedRoute;

      const noIndex = route.snapshot.url.some(segment => segment.path === 'panel-admina');

      if (noIndex) {
        this.robots.setNoIndex();
      } else {
        this.robots.setIndexable();
      }
    });
  }
}
